import React from "react";
import { cn } from "@/utils/utils";

import { StoryJson } from "@/types/Story.type";
import Website from "@/common/constants/webstite";

import Image from "@/components/ui/Image";
import LinkElement from "@/components/LinkElement";
import TextDateTime from "@/components/TextDateTime";
import ImageConstant from "@/common/constants/image";

export default function NArticleCard({
	data,
	className,
	classNameImage,
	type,
}: {
	data: StoryJson;
	className?: string;
	classNameImage?: string;
	type?: "left" | "center" | "horizontal";
}) {
	return (
		<LinkElement
			href={`${Website.LINK.PAGE.BLOG}/${
				data?.collections?.[0]?.handle || "all"
			}/${data.handle}`}>
			{type === "horizontal" ? (
				<article className={cn("flex items-center gap-2 md:gap-4", className)}>
					<Image
						src={data?.images[0]?.url || ""}
						alt={data.title}
						width={166}
						height={166}
						objectFit={"cover"}
						className={cn(
							"w-[122px] h-[122px] md:w-[166px] md:h-[166px] object-cover",
							classNameImage
						)}
						placeholder={"blur"}
						blurDataURL={ImageConstant.BlurDataURL}
					/>
					<div className="flex flex-col justify-center gap-4">
						<p className="text-lg line-clamp-2 font-semibold hover:text-red-500 transition-all h-[48px]">
							{data.title}
						</p>

						{/* <p className="text-sm text-gray-400 h-[18px]">
              {StoryModel.convertTimestampToddMONTHyyyy(data.date_published)}
            </p> */}
						<TextDateTime
							ts={data.date_published ? data.date_published : data.date_modified}
							className="line-clamp-1 text-sm text-gray-400 h-[18px]"
						/>
					</div>
				</article>
			) : (
				<article className={cn("", className)}>
					<Image
						src={data?.images?.[0]?.url || ""}
						alt={data.title}
						width={300}
						height={300}
						objectFit={"cover"}
						className={cn(
							"w-[187px] md:w-[293px] h-[187px] md:h-[293px] object-cover",
							classNameImage
						)}
						placeholder={"blur"}
						blurDataURL={ImageConstant.BlurDataURL}
					/>
					<div className={`${type === "center" ? "text-center" : "text-left"}`}>
						<p className="text-sm text-gray-400 my-2 uppercase line-clamp-1 leading-[15px] h-[15px]">
							{data?.collections?.[0]?.title || "all"}
						</p>
						<p className="text-lg line-clamp-2 mt-2 mb-4 font-semibold hover:text-red-500 transition-all leading-[20px] h-[40px]">
							{data.title}
						</p>
						{/* <p className="mt-2 text-sm text-gray-400 line-clamp-1 leading-[15px] h-[15px]">
              {StoryModel.convertTimestampToddMONTHyyyy(data.date_published ? data.date_published : data.date_modified)}
            </p> */}
						<TextDateTime
							className="mt-2 text-sm text-gray-400 line-clamp-1 leading-[15px] h-[15px]"
							ts={data.date_published ? data.date_published : data.date_modified}
						/>
					</div>
				</article>
			)}
		</LinkElement>
	);
}
